const ChevronUp = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.83354L0 1.83354L1.16667 0.66687L5 4.5002L8.83333 0.66687L10 1.83354L5 6.83354Z"
        fill="#343434"
      />
    </svg>
  );
};

export default ChevronUp;
